<template>
  <div>
    <TitlePage :title="$t('test')+' '+$t('booking')"></TitlePage>

    <v-layout wrap>

      <v-flex md12 class="d-flex">
        <v-chip dense outlined text type="info" class="mr-1">Loggato come {{user.name}} {{user.surname}} - {{user.email}} - Id: {{user._id}}</v-chip>
        <v-chip dense outlined text type="info" class="mr-1" v-if="center != null">Centro Sportivo: {{center.name}}</v-chip>
        <v-chip dense outlined text type="info" class="mr-1" v-if="field != null">Campo: {{field.name}}</v-chip>
      </v-flex>

      <v-flex md12 class="d-flex">
      <v-select v-model="sport_selected" :items="sports_list" label="Sport" item-text="name" item-value="_id" solo></v-select>
      </v-flex>

      <v-flex md12 class="d-flex">
        <v-card v-if="calendar != null && sport_selected != null" class="calendar-full">

          <v-slide-group>
            <v-slide-item v-for="day in this.calendar.days" :key="new Date(day.date).toLocaleString()">


              <div class="item-calendar">
                <v-btn depressed block color="accent" small text style="background:#e4dcff">
                  {{new Date(day.date).toLocaleDateString('it-IT', { weekday: 'short' })}}
                  <span style="font-size: 24px;margin: 0 15px;">
                  {{new Date(day.date).getDate()}}
                  </span>
                  {{new Date(day.date).toLocaleDateString('it-IT', { month: 'short' })}}
                </v-btn>

                <v-alert class="box-calendar" v-for="slot in day.slots" dense text :key="new Date(day.date).toLocaleString()+slot.slot_id"
                         v-bind:class="[(slot.active) ? 'available' : 'not-available', (slot.booked) ? 'booked':'']"
                         border="left"
                         colored-border :color="(slot.active) ? 'success' : 'error'"
                         style="min-height: 68px;"
                         @click="bookNow(slot)"
                >
                  <span class="time-slot">{{slot.start}} - {{slot.end}}</span>
                  <template v-if="slot.booked">
                    <span style="font-size: 20px; display: block; font-weight: 600; color: #f9546b; text-transform: uppercase;text-decoration: underline;">
                        PRENOTATO
                      </span>
                    <span style="font-size: 12px">
                      Cod. {{slot.code}}
                    </span>
                  </template>
                  <template v-else-if="slot.active">
                    <template v-if="!slot.promo">
                      <span style="color: #279863;font-weight: 800;">{{getPrice(slot, 'total').toFixed(2)}} €</span>
                      <span v-if="getPrice(slot, 'online') == 0" style="font-size: 10px;display: block;font-weight: 600;color: darkblue;text-transform: uppercase;">
                        Paghi tutto al campo
                      </span>
                      <span v-else-if="getPrice(slot, 'center') == 0" style="font-size: 10px;display: block;font-weight: 600;color: darkblue;text-transform: uppercase;">
                        Paghi tutto online
                      </span>
                      <span v-else style="font-size: 10px;display: block;">di cui {{getPrice(slot, 'online').toFixed(2)}} online</span>
                    </template>
                    <template v-else-if="slot.promo && !slot.promo_sa">
                      <span style="color: red; font-weight: bolder">
                        {{getPrice(slot, 'total').toFixed(2)}} €
                      </span>
                      <span v-if="getPrice(slot, 'online') == 0" style="font-size: 10px;display: block;font-weight: 600;color: darkblue;text-transform: uppercase;">
                        Paghi tutto al campo
                      </span>
                      <span v-else-if="getPrice(slot, 'center') == 0" style="font-size: 10px;display: block;font-weight: 600;color: darkblue;text-transform: uppercase;">
                        Paghi tutto online
                      </span>
                      <span v-else style="font-size: 10px;display: block;">di cui {{getPrice(slot, 'online').toFixed(2)}} online</span>
                      <span style="background: red; color: rgb(255, 255, 255); font-weight: 600; position: absolute; top: 0px; right: 0px; border-radius: 3px;font-size: 13px;padding: 0px 4px;">
                       -{{slot.promo.value}}{{(slot.promo.type == 'fixed') ? '€' : '%'}}
                      </span>
                    </template>
                    <template v-else-if="slot.promo && slot.promo_sa">
                      <span style="color: red; font-weight: bolder">
                        {{getPrice(slot, 'total').toFixed(2)}} €
                      </span>
                      <span v-if="getPrice(slot, 'online') == 0" style="font-size: 10px;display: block;font-weight: 600;color: darkblue;text-transform: uppercase;">
                        Paghi tutto al campo
                      </span>
                      <span v-else-if="getPrice(slot, 'center') == 0" style="font-size: 10px;display: block;font-weight: 600;color: darkblue;text-transform: uppercase;">
                        Paghi tutto online
                      </span>
                      <span v-else style="font-size: 10px;display: block;">di cui {{getPrice(slot, 'online').toFixed(2)}} online</span>
                      <span style="background: #ffbf00; color: rgb(255, 255, 255); font-weight: 600; position: absolute; top: 0px; right: 0px; border-radius: 3px;font-size: 13px;padding: 0px 4px;">
                       -{{slot.promo.value}}{{(slot.promo.type == 'fixed') ? '€' : '%'}}
                      </span>
                    </template>
                  </template>
                </v-alert>
              </div>


            </v-slide-item>
          </v-slide-group>


        </v-card>
      </v-flex>

      <div class="text-center">
        <v-dialog v-model="book_modal" width="500">
          <v-card>

            <v-card-title class="text-h5 lighten-2">
              Conferma prenotazione
            </v-card-title>

            <v-card-text>
              {{ slot_to_book}}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="book_modal=false;slot_to_book=null">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn color="success" text @click="submitBooking(true)">
                {{ $t('insert') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>


    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "BookingsTest",
  components: {TitlePage},
  data() {
    return {
      user: {
        _id: '6274e35cb0d3ea5f6cf680ee',
        name: 'Test1',
        surname: 'Test1',
        email: 'test@utente1.it'
      },
      center_slug: 'centro-sportivo-az',
      field_slug: 'test-calcio-a-8',
      calendar: null,
      field: null,
      center: null,
      sports_list: null,
      sport_selected: null,
      slot_to_book: null,
      book_modal: false
    }
  },
  async created(){
    this.setLoading(true);
    var calendar_info = await this.getCalendar({center_slug:this.center_slug, field_slug:this.field_slug})
    this.sports_list = calendar_info.result.field.sports
    this.sport_selected = calendar_info.result.field.sports[0]._id

    this.calendar = {...calendar_info.result.calendar}
    this.center = {...calendar_info.result.center}
    this.field = {...calendar_info.result.field}
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'getItemsSports': 'sports/index',
      'getCalendar': 'bookings/getCalendar',
      'storeItem': 'bookings/store'
    }),
    bookNow(slot){
      if(slot.active && !slot.booked){
        this.slot_to_book = JSON.parse(JSON.stringify(slot))
        this.slot_to_book.center = this.center._id
        this.slot_to_book.field = this.field._id
        this.slot_to_book.user = this.user._id
        this.slot_to_book.sport_selected = this.sport_selected
        this.book_modal = true
      }
    },
    async submitBooking(){

        await this.setLoading(true);
        var result = await this.storeItem(this.slot_to_book)
        await this.setLoading(false);

        if(result.success){
          if(result.result.result){
            if(!result.result.result.payed){

              window.location.href = result.result.result.payment_url;

            }else {

              this.setNotification({
                active: true,
                color: 'success',
                mode: 'multi-line',
                text: this.$t('bookingSuccess')
              })

              this.slot_to_book = null
              this.book_modal = false

              var calendar_info = await this.getCalendar({center_slug:this.center_slug, field_slug:this.field_slug})
              this.calendar = {...calendar_info.result.calendar}

            }

          }else {

            this.setNotification({
              active: true,
              color: 'error',
              mode: 'multi-line',
              text: result
            })
          }


        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

        }
    },
    getPrice(slot, type = 'online'){
      var find = _.find(slot.prices, {sport_id: this.sport_selected})
      if(!find){
        return slot.slot_id
      }else{
        if(type == 'online'){
          return find.value_ac
        }else if(type == 'center') {
          return find.value_ce
        }else if(type == 'total'){
          return find.value_ac + find.value_ce
        }
      }
    },
  },
  mounted() {

  },
}
</script>

<style scoped>

</style>